export const DIRECTION_OPTIONS = [
  { value: 'entrada', label: 'Entrada' },
  { value: 'saida', label: 'Saída' },
  { value: 'ambos', label: 'Ambos' },
];

export const DIRECTION_TRANSLATIONS: Record<string, string> = {
  North: 'Norte',
  South: 'Sul',
  East: 'Leste',
  West: 'Oeste',
  Northeast: 'Nordeste',
  Northwest: 'Noroeste',
  Southeast: 'Sudeste',
  Southwest: 'Sudoeste',
};

export const initialValues = {
  name: '',
  serialWiegan: '',
  mac: '',
  direction: '',
  counter: 0,
  receptors: 1,
  hosts: 1,
  portQuantity: 1,
  finalPortQuantity: 1,
  roomId: '',
  tenant_id: '',
}; 